import styled, { css } from 'styled-components'
import { Typography } from '@material-ui/core'

export const Description = styled(Typography)(
  ({ theme }) => css`
    min-height: 2em;
    padding: ${theme.spacing(2.5, 0, 3, 0)};
  `
)
